<div class="acquisition-notification-content">
    @if (acquisitionViewData().icon) {
        <i class="acquisition-notification-icon {{ acquisitionViewData().icon }}"></i>
    }
    <div class="acquisition-notification-message">
        @if (acquisitionViewData().title) {
            <div class="acquisition-notification-header">{{ acquisitionViewData().title }}</div>
        }
        <div class="acquisition-notification-text">{{ acquisitionViewData().content }}</div>
    </div>
</div>
<div class="acquisition-notification-close theme-ex" (click)="hideAcquisition()"></div>
